import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";

/**
 * Close the current stacked view when navigating
 */
@Injectable()
export class CanDeactivateStackedModal implements CanDeactivate<any> {

    constructor(private stackedPageService: FUIStackedPageService) {
    }

    canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot,
                  nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.stackedPageService.isOpen()) {
            this.stackedPageService.requestCancelCurrentView();
            // currently there is a bug on angular that when the back button is used and the canDeactivate return false
            // it stills change the browser history causing the history to get in a wrong state. So this is just an
            // workaround until they fix this angular bug
            history.pushState({}, "", currentState.url);
            return false;
        } else {
            return true;
        }
    }
}
